import {
  mobileConfigurationByIdEndpoint,
  mobileConfigurationEndpoint,
  userGroupsEndpoint,
  userTypesEndpoint,
  zipEndpoint
} from "../endpoints";

export const AddEndpoint = {
  getConfiguration: mobileConfigurationByIdEndpoint,
  createConfiguration: mobileConfigurationEndpoint,
  uploadZip: zipEndpoint,
  userTypes: userTypesEndpoint,
  userGroups: userGroupsEndpoint
};
